import { wait } from './wait'

export const waitForCondition = async <T>(
    condition: () => T,
    maxWait: number = 5000,
    checkEvery: number = 200
): Promise<T> => {
    let timeSpent = 0
    while (timeSpent < maxWait && !condition()) {
        timeSpent += checkEvery
        await wait(checkEvery)
    }
    return condition()
}
